import script from "./IndirectCustomerNumbers.vue?vue&type=script&setup=true&lang=js"
export * from "./IndirectCustomerNumbers.vue?vue&type=script&setup=true&lang=js"

import "./IndirectCustomerNumbers.vue?vue&type=style&index=0&id=583d8894&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583d8894"]])

export default __exports__